import DashboardIndex from "@/components/claim/dashboard/dashboardIndex.vue";

let routesDashboard = [
  {
    path: '',
    name: "dashboard-claim",
    component: DashboardIndex
  }
];

export default routesDashboard;
